import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bbc6612c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  ref: "questionContainer",
  style: {
    "height": "100%",
    "overflow-y": "scroll"
  }
};
const _hoisted_2 = {
  class: "chat-bubble"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  key: 1,
  class: "answer-pos"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"spinner\" data-v-bbc6612c><div class=\"rect1\" data-v-bbc6612c></div><div class=\"rect2\" data-v-bbc6612c></div><div class=\"rect3\" data-v-bbc6612c></div><div class=\"rect4\" data-v-bbc6612c></div></div>", 1);
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  class: "answer",
  ref: "answer"
};
const _hoisted_10 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_avatar = _resolveComponent("el-avatar");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: "logic",
    style: _normalizeStyle({
      height: $props.content.height + 'px',
      paddingBottom: $data.answerHeight + 'px'
    })
  }, [$data.init ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questionsAndAnswers, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "chat"
    }, [item.question_content ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createVNode(_component_el_avatar, {
      style: {
        "min-width": "40px"
      },
      shape: "square",
      src: $props.content.logic.content.customer_setting.customer_avatar
    }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      class: "ql-editor",
      innerHTML: item.question_content
    }, null, 8, _hoisted_3)])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
      class: "chat-bubble-answer",
      innerHTML: item.answer_content
    }, null, 8, _hoisted_5), _createVNode(_component_el_avatar, {
      shape: "square",
      src: $props.content.logic.content.customer_setting.customer_service_avatar
    }, null, 8, ["src"])]))]);
  }), 128)), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true)], 512)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.toBeAnswers, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "rounded",
      style: _normalizeStyle({
        background: $props.content.buttomColor,
        color: $props.content.buttomTextColor,
        fontSize: $props.content.buttonSize + 'px',
        borderRadius: $props.content.buttonRadius + 'px'
      }),
      onClick: $event => $options.handleClickAnswer(item)
    }, _toDisplayString(item.answer_content), 13, _hoisted_10);
  }), 128))], 512)], 4), _renderSlot(_ctx.$slots, "deles", {}, undefined, true)]);
}